import type { FrankieOneTenantRegion } from './FrankieOne/types';
import type { SumsubTenantRegion } from './Sumsub/types';

export type KycConfigRegion =
  | { kycProvider: 'frankieOne'; tenantRegion: FrankieOneTenantRegion }
  | { kycProvider: 'sumsub'; tenantRegion: SumsubTenantRegion };

const KYC_CONFIG_REGIONS: Record<string, KycConfigRegion> = {
  // dev
  '1a50d9a3-66f6-4ef0-9c2d-f36656e84501': { kycProvider: 'frankieOne', tenantRegion: 'au' },
  '9ab3d98e-4e71-4afb-9b2b-6924ab875e65': { kycProvider: 'frankieOne', tenantRegion: 'au' },
  '2d06c721-c9fa-419b-ae39-635c4dc4ec19': { kycProvider: 'frankieOne', tenantRegion: 'eu' },
  'ef69fc18-e597-44e5-95e8-ea90ebf38ce5': { kycProvider: 'frankieOne', tenantRegion: 'eu' },
  'ce44c4f7-f0fb-4082-abea-2b853962418f': { kycProvider: 'sumsub', tenantRegion: 'global' },
  '5dcfeb73-4c91-486f-b69a-b73278f6a263': { kycProvider: 'sumsub', tenantRegion: 'global' },
  '86806e79-62fe-44cd-a1a0-cc75ffa09fa6': { kycProvider: 'frankieOne', tenantRegion: 'lac' },
  'eab6a0b8-f739-48c5-8e13-ed3aeff2df4b': { kycProvider: 'frankieOne', tenantRegion: 'lac' },
  '55222a82-817b-4465-8f26-698520178bcb': { kycProvider: 'frankieOne', tenantRegion: 'nz' },
  '280d263b-2807-4448-ab6b-19716470e5dd': { kycProvider: 'frankieOne', tenantRegion: 'nz' },
  '2644853B-8750-48DF-ABBD-DEB6B3EBB699': { kycProvider: 'sumsub', tenantRegion: 'nz' },
  '0ECF20CD-A87B-40BC-B827-0107B9C825AD': { kycProvider: 'sumsub', tenantRegion: 'nz' },
  // prod
  '8c0e7fa5-f628-4a36-b435-f74af0568986': { kycProvider: 'frankieOne', tenantRegion: 'au' },
  '95cb93d7-2618-4fe9-8fd0-33e5bcf86290': { kycProvider: 'frankieOne', tenantRegion: 'au' },
  '0f5db976-273b-4f4d-bafc-6e506fdd11df': { kycProvider: 'frankieOne', tenantRegion: 'eu' },
  '6930477a-8746-4d6c-93d6-29ff1a6220bb': { kycProvider: 'frankieOne', tenantRegion: 'eu' },
  'A3CF4EEF-97DA-434C-848C-8A9CAC6BFB07': { kycProvider: 'sumsub', tenantRegion: 'eu' },
  'd34c32a2-865d-4103-8099-dbae912a2787': { kycProvider: 'sumsub', tenantRegion: 'global' },
  'a7116648-aa02-48de-920b-c56053dd9a52': { kycProvider: 'frankieOne', tenantRegion: 'lac' },
  'e8acb3ff-6ceb-425f-8fb5-d6087d983c83': { kycProvider: 'frankieOne', tenantRegion: 'lac' },
  'eddda79c-cacd-44a9-ad4a-3cf5073dca73': { kycProvider: 'sumsub', tenantRegion: 'lac' },
  '54aa3a76-85bd-4b86-b699-e50b7a63e45b': { kycProvider: 'frankieOne', tenantRegion: 'nz' },
  '57e47f29-f235-4b49-b755-4797ae39ceef': { kycProvider: 'frankieOne', tenantRegion: 'nz' },
  '462d650d-f353-4295-b3b1-442233392f74': { kycProvider: 'sumsub', tenantRegion: 'nz' },
};

export function tenantRegionForKycConfigId(kycConfigId: string): KycConfigRegion | undefined {
  return KYC_CONFIG_REGIONS[kycConfigId];
}
